import { Link } from 'react-router-dom'

export default function BlogCard({ post }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group flex flex-col bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all duration-200"
    >
      {/* Image placeholder */}
      <div className="bg-[#F8FAFC] h-44 flex items-center justify-center border-b border-slate-100 shrink-0">
        <div className="text-center px-4">
          <div className="flex flex-wrap gap-1.5 justify-center mb-3">
            {post.tags.map(tag => (
              <span
                key={tag}
                className="text-xs font-medium uppercase tracking-wide bg-kart-blue/10 text-kart-blue px-2 py-1 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
          <p className="text-slate-400 text-xs font-mono">{post.slug}.mdx</p>
        </div>
      </div>

      {/* Content */}
      <div className="p-6 flex flex-col flex-1 gap-3">
        <div className="flex items-center gap-3 text-xs text-slate-400">
          <time dateTime={post.date}>
            {new Date(post.date).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </time>
          <span>·</span>
          <span>{post.readTime} de lecture</span>
        </div>

        <h2 className="font-display font-semibold text-lg text-kart-night leading-snug group-hover:text-kart-blue transition-colors">
          {post.title}
        </h2>

        <p className="text-slate-500 text-sm leading-relaxed flex-1">
          {post.excerpt}
        </p>

        <span className="text-kart-blue text-sm font-medium mt-auto">
          Lire l'article →
        </span>
      </div>
    </Link>
  )
}
